import ProxyBase from '../../../../../../core/proxies/ProxyBase'

export class IndustryScaleProxy extends ProxyBase {
  getIndustryScaleTable(params) {
    return this.get('Scale', params)
  }
  downloadIndustryScale(params) {
    return this.post('Scale/Export', params, {}, 'download')
  }
}

export default new IndustryScaleProxy('IndustryOverview/')
